const TRANSACTION = '/transaction';
const DASHBOARD = '/dashboard';
const MY_ACCOUNTS = '/my-accounts';

const MANAGED = '/managed/';

export default {
  HOME: '/',
  HELP: '/help',
  LOGIN: '/login',
  SIGN_UP: '/sign-up',
  SIGN_UP_ORPHAN: '/sign-up/orphan',
  CHANGE_PASSWORD: '/change-password',
  EXPENSE_DETAILS: '/expense-details/list',
  REIMBURSE_ME: `${TRANSACTION}/reimburse-me`,
  REIMBURSE_ME_FILE_UPLOAD: `${TRANSACTION}/reimburse-me/file-upload`,
  REIMBURSE_ME_FILE_SCAN: `${TRANSACTION}/reimburse-me/file-scan`,
  REIMBURSE_ME_CLAIM_INFO: `${TRANSACTION}/reimburse-me/claim-info`,
  REQUEST_BILL_PAY: `${TRANSACTION}/request-bill-pay`,
  REQUEST_BILL_PAY_FILE_UPLOAD: `${TRANSACTION}/request-bill-pay/file-upload`,
  REQUEST_BILL_PAY_FILE_SCAN: `${TRANSACTION}/request-bill-pay/file-scan`,
  REQUEST_BILL_PAY_CLAIM_INFO: `${TRANSACTION}/request-bill-pay/claim-info`,
  USE_MY_MONEY: '/use-my-money',
  USE_MY_MONEY_READY_TO_SCAN: '/use-my-money/ready-to-scan',
  USE_MY_MONEY_SUMMARY: '/use-my-money/summary',
  USE_MY_MONEY_SETUP_FIELDS: '/use-my-money/summary/setup-fields',
  RECEIPT_VAULT: `${TRANSACTION}/receipt-vault`,
  AUTO_INVESTMENTS: '/auto-investments',
  ERROR: '/error',
  CARDS: '/cards',
  CARD_DETAILS: '/card-details',
  ONE_TIME_LINKS: '/documents/one-time-links/:hashId',
  POLL: '/poll',
  ID_SCAN: (url?: string) => `/id-scan/${url || ':url'}`,
  VERIFY: '/verify',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD_LINK_SENT: '/forgot-password-link-sent',
  RESET_PASSWORD: '/reset-password',
  USER_ACTIVATION: '/user-activation',
  EMAIL_CONFIRMATION: '/emails/verification',
  START_INVESTING: '/start-investing',
  MANAGE_PROFILE: '/manage-profile',
  MY_DOCUMENTS: '/my-documents',
  MY_DOCUMENTS_RECEIPTS: '/my-documents/receipts',
  MY_DOCUMENTS_LMN: '/my-documents/lmn',
  MY_DOCUMENTS_LMN_VIEW_MOBILE: (itemId?: string) => `/my-documents/lmn/${itemId || ':itemId'}/view`,
  MY_DOCUMENTS_LMN_EDIT_MOBILE: (itemId?: string) => `/my-documents/lmn/${itemId || ':itemId'}/edit`,
  MY_DOCUMENTS_STATEMENTS: '/my-documents/statements',
  MY_DOCUMENTS_TAX_FORMS: '/my-documents/tax-forms',

  SPENDS_BY_ID: (deductibleId?: string | number, yearId?: string) =>
    `/spends/${deductibleId || ':deductibleId'}/year/${yearId || ':yearId'}`,
  INVESTMENTS: '/investments',

  INVESTMENTS_UPDATE_RISK_PORTFOLIO: '/investments/update-risk-portfolio',
  BUY_SELL: '/buy-sell',

  MANAGED_SELL_INVESTMENTS: (accountId?: string) => `${MANAGED}sell-investments/${accountId || ':accountId'}`,
  MANAGED_SWITCH_QUESTIONNAIRE: (accountId?: string) =>
    `${MANAGED}switch/questions/${accountId || ':accountId'}`,
  MANAGED_SWITCH_FUNDING_AMOUNT: (accountId?: string) =>
    `${MANAGED}switch/funding/${accountId || ':accountId'}`,
  MANAGED_SWITCH_ALLOCATION: (accountId?: string) =>
    `${MANAGED}switch/allocation/${accountId || ':accountId'}`,

  NOTIFICATIONS: '/notifications',
  MY_ACCOUNTS: `${DASHBOARD}${MY_ACCOUNTS}`,
  MY_ACCOUNTS_HSA: `${DASHBOARD}${MY_ACCOUNTS}/hsa`,
  DOWNLOAD_FILE_BY_QR_LINK: `${TRANSACTION}/reimburse-me/qr-codes`,

  MY_ACCOUNTS_DETAILS: (accountId?: string | number) =>
    `${DASHBOARD}${MY_ACCOUNTS}/${accountId || ':accountId'}`,
  CONTRIBUTION: (accountId?: string | number) =>
    `${DASHBOARD}${MY_ACCOUNTS}/${accountId || ':accountId'}/contribution`,

  SELF_DIRECTED: (accountId?: string) => `/self-directed/${accountId || ':accountId'}`,
  SELF_DIRECTED_INVEST_MORE: (accountId?: string, initialAmount?: number) =>
    `/self-directed/invest-more/${accountId || ':accountId'}${
      initialAmount ? `?initialAmount=${initialAmount}` : ''
    }`,

  SELF_DIRECTED_EMPTY_SWITCH_QUESTIONNAIRE: (accountId?: string) =>
    `/self-directed/switch/empty/questionnaire/${accountId || ':accountId'}`,
  SELF_DIRECTED_EMPTY_SWITCH_SELECT: (accountId?: string) =>
    `/self-directed/switch/empty/select/${accountId || ':accountId'}`,
  SELF_DIRECTED_EMPTY_SWITCH_ALLOCATION: (accountId?: string) =>
    `/self-directed/switch/empty/allocation/${accountId || ':accountId'}`,

  MANAGED_SWITCH_EMPTY_QUESTIONNAIRE: (accountId?: string) =>
    `${MANAGED}switch/questions/empty/${accountId || ':accountId'}`,
  MANAGED_SWITCH_EMPTY_FUNDING_AMOUNT: (accountId?: string) =>
    `${MANAGED}switch/funding/empty/${accountId || ':accountId'}`,
  MANAGED_SWITCH_EMPTY_ALLOCATION: (accountId?: string) =>
    `${MANAGED}switch/allocation/empty/${accountId || ':accountId'}`,

  SELF_DIRECTED_SWITCH_QUESTIONNAIRES: (accountId?: string) =>
    `/self-directed/switch/questionnaires/${accountId || ':accountId'}`,
  SELF_DIRECTED_SWITCH_SELECT: (accountId?: string) =>
    `/self-directed/switch/select/${accountId || ':accountId'}`,
  SELF_DIRECTED_SWITCH_ALLOCATION: (accountId?: string) =>
    `/self-directed/switch/allocation/${accountId || ':accountId'}`,
  SELF_DIRECTED_SELL_INVESTMENTS: (accountId?: string) =>
    `/self-directed/sell-investments/${accountId || ':accountId'}`,
  SELF_DIRECTED_ALLOCATION: (accountId?: string | null) =>
    `/self-directed/allocation/${accountId || ':accountId'}`,
  SELF_DIRECTED_QUESTIONNAIRE: (accountId?: string | null) =>
    `/self-directed/questions/${accountId || ':accountId'}`,

  TRANSACTION_DETAILS_POSTING: (accountId?: string | number, postingId?: string | number) =>
    `${DASHBOARD}${MY_ACCOUNTS}/${accountId || ':accountId'}${TRANSACTION}/${
      postingId || ':postingId'
    }/posting`,
  TRANSACTION_DETAILS_CLAIM: (accountId?: string | number, claimId?: string | number) =>
    `${DASHBOARD}${MY_ACCOUNTS}/${accountId || ':accountId'}${TRANSACTION}/${claimId || ':claimId'}/claim`,
  TAX_FORMS: (accountId?: string) => `/tax-forms/${accountId || ':accountId'}`,
  EXPENSES_TRANSACTION_DETAILS_CLAIM: (claimId?: string | number) =>
    `${TRANSACTION}/${claimId || ':claimId'}/claim`,
  EXPENSES_TRANSACTION_DETAILS_POSTING: (postingId?: string | number) =>
    `${TRANSACTION}/${postingId || ':postingId'}/posting`,
  STATEMENTS: (accountId?: string) => `/statements/${accountId || ':accountId'}`,
  HEALTH_PLAN_SPENDS_DETAILS: (healthPlanId?: string, yearId?: string) =>
    `/health-plans/${healthPlanId || ':healthPlanId'}/year/${yearId || ':yearId'}`,
};
